import { render, staticRenderFns } from "./RegTrabajador.vue?vue&type=template&id=64e45f42&scoped=true&"
import script from "./RegTrabajador.vue?vue&type=script&lang=js&"
export * from "./RegTrabajador.vue?vue&type=script&lang=js&"
import style0 from "./RegTrabajador.vue?vue&type=style&index=0&id=64e45f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e45f42",
  null
  
)

export default component.exports